import { IDeviceInfo } from '@williamhill/rosi-ui-shared/src/types';

export const getDeviceInfo = (): IDeviceInfo => {
  const deviceInfo = localStorage.getItem('deviceInfo') as string;
  return JSON.parse(deviceInfo) as IDeviceInfo;
};

export const setDeviceInfo = (deviceInfo: IDeviceInfo) => {
  localStorage.setItem('deviceInfo', JSON.stringify(deviceInfo));
};
